// extracted by mini-css-extract-plugin
export default {"wrapper":"userAvatar_wrapper__sD3OG","rootTypeRounded":"userAvatar_rootTypeRounded__PSYG0","iconWrap":"userAvatar_iconWrap__lVilH"};